import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { Container, Nav, Navbar, NavLink } from 'react-bootstrap';
import logo from '../images/logo1.svg'
import twitter from '../images/twitter.svg'
import facebook from '../images/facebook.svg'
import instagram from '../images/instagram.svg'
import logout from '../images/logout.svg'
import axios from 'axios';

const Header = ({ imagTag = '', active = {}, role = 1, events = [] }) => {
    const [filteredData, setFilteredData] = useState(events);
    const navigate = useNavigate();
    const handleLogout = () => {
        sessionStorage.removeItem('token');
        navigate('/login');
    };
    const handleRedirect = (e) => {
        e.preventDefault();
        navigate('/dashboard');
    }
    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/dashboard');
    }

    useEffect(() => {
      const fetchData = async () => {
          const token = sessionStorage.getItem('token');
          if (!token) {
              navigate('/login');
              return;
          }

          try {
              const response = await axios.post(`${process.env.REACT_APP_API_URL}/dashboard`, {}, {
                  headers: {
                      'Authorization': `Bearer ${token}`
                  }
              });

              const { events,estimates, PMid,role,active_event,close_event,total_count,total_pending_approvals,approvals} = response.data.data;
              setFilteredData(events || []);
              sessionStorage.setItem('clientId', PMid.clientId || '');
              sessionStorage.setItem('pmId', PMid.PMid || '');
              sessionStorage.setItem('role', role || '');
          } catch (error) {
              console.log(error.message);
              navigate('/login');
          }
      };

      fetchData();
  }, [navigate]);

    const showEstimatesPage = (e, item) => {
      e.stopPropagation()
      navigate(`/dashboard/showestimates/${item.EventId}`)
    }

    const showCreativesPage = (e, item) => {
      e.stopPropagation()
      const role = sessionStorage.getItem('role')
      const url = role == 2 ? `/dashboard/showpmcreative/${item.EventId}` : `/dashboard/showcreativeevent/${item.EventId}` 
      navigate(url)
    }

    const showPostEventPage = (e, item) => {
      e.stopPropagation()
      navigate(`/dashboard/showpostevent/${item.EventId}`)
    }
    return (
      <header className={`${role == 1 ? 'mb-2' : 'border-bottom pb-2'}`}>
        <div className="row align-items-center mx-auto header">
          <div className="d-flex justify-content-between align-items-center flex-wrap p-0 flex-box">
            <Navbar bg="white" className="p-0">
              <Container>
                <Navbar.Brand href="/dashboard">
                  <img
                    src={logo}
                    height="75"
                    className="d-inline-block align-top"
                    alt="Exicon logo"
                  />
                </Navbar.Brand>
              </Container>
            </Navbar>
            <Navbar bg="white" className="text-nowrap align-items-end">
              <Container className="">
                <Nav className="me-auto">
                  <NavLink
                    style={{
                      color: window.location.pathname == "/dashboard"
                        ? "#C12227"
                        : "#808285",
                    }}
                    href="/dashboard"
                  >
                    Dashboard
                  </NavLink>
                  {
                    role != 3 && (
                      <>
                        <NavLink
                          style={{
                            color: window.location.pathname.includes(
                              "/dashboard/showestimates"
                            )
                              ? "#C12227"
                              : "#808285",
                          }}
                          className="estimate_link"
                          aria-disabled
                        >
                          Estimates
                          <ul className="nav-links-hover">
                            {filteredData?.map((item) => (
                              <li
                                key={item.EventId} // Add a unique key to each list item
                                onClick={(e) => showEstimatesPage(e, item)}
                              >
                                {item.Eventname}
                              </li>
                            ))}
                          </ul>
                        </NavLink>
                        {/* <NavLink style={{
                            color: window.location.pathname.includes(
                              "/#"
                            )
                              ? "#C12227"
                              : "#808285",
                          }} href="/">
                          Approvals
                        </NavLink> */}
                        <NavLink style={{
                            color: window.location.pathname.includes(
                              "/dashboard/showcreativeevent"
                            )
                              ? "#C12227"
                              : "#808285",
                          }} 
                          className="estimate_link"
                          aria-disabled
                          >
                          Creatives
                          <ul className="nav-links-hover">
                            {filteredData?.map((item) => (
                              <li
                                key={item.EventId} // Add a unique key to each list item
                                onClick={(e) => showCreativesPage(e, item)}
                              >
                                {item.Eventname}
                              </li>
                            ))}
                          </ul>
                        </NavLink>
                        <NavLink style={{
                            color: window.location.pathname.includes(
                              "/postevent"
                            )
                              ? "#C12227"
                              : "#808285",
                          }} className='estimate_link'
                          aria-disabled>
                          Post Event
                          <ul className="nav-links-hover">
                            {filteredData?.map((item) => (
                              <li
                                key={item.EventId} // Add a unique key to each list item
                                onClick={(e) => showPostEventPage(e, item)}
                              >
                                {item.Eventname}
                              </li>
                            ))}
                          </ul>
                        </NavLink>
                      </>
                    )
                  }
                </Nav>
              </Container>
              <Container
                className="d-flex justify-content-between"
                style={{ width: "10rem" }}
              >
                <a
                  className="flex-shrink-0"
                  title="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/exicongrp"
                >
                  <img
                    className="img-fluid"
                    src={facebook}
                    alt="Facebook"
                    style={{ width: "32px" }}
                  />
                </a>
                <a
                  className="flex-shrink-0"
                  title="Twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.twitter.com/exiconGroup"
                >
                  <img
                    className="img-fluid"
                    src={twitter}
                    alt="Twitter"
                    style={{ width: "32px" }}
                  />
                </a>
                <a
                  className="flex-shrink-0"
                  title="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/exicongroup"
                >
                  <img
                    className="img-fluid"
                    src={instagram}
                    alt="Instagram"
                    style={{ width: "32px" }}
                  />
                </a>
              </Container>
            </Navbar>
            <Navbar bg="white" className="align-items-end">
              <Container>
                <span
                  className="d-none d-md-inline pl-3"
                  title="Logout"
                  style={{ color: "#123abc", cursor: "pointer" }}
                  onClick={handleLogout}
                >
                  Logout
                  <img
                    id="a1"
                    src={logout}
                    alt="Logout"
                    className="img-fluid ml-2"
                    style={{ height: "32px" }}
                  />
                </span>
              </Container>
            </Navbar>
          </div>
        </div>

        {/* Navbar Section */}
        {/* <nav className="navbar navbar-expand-lg">
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 6h16M4 12h16M4 18h16"
                  stroke="#c00707"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="col-md-1"></ul>
            <ul className="navbar-nav col-md-8 justify-content-between">
              {role == 2 || role == 1 ? (
                <>
                  <li
                    className={
                      active.dashboard
                        ? "nav-item navbarActive navbarPadding"
                        : "nav-item navbarPadding"
                    }
                  >
                    <a
                      className="nav-link"
                      href=""
                      onClick={(e) => handleDashboard(e)}
                      style={{ color: "#fff" }}
                    >
                      Dashboard
                    </a>
                  </li>
                  <li
                    className={
                      active.estimates
                        ? "nav-item navbarActive navbarPadding"
                        : "nav-item navbarPadding"
                    }
                  >
                    <a
                      className="nav-link"
                      href=""
                      onClick={(e) => handleDashboard(e)}
                      style={{ color: "#fff" }}
                    >
                      Estimates
                    </a>
                  </li>
                  <li
                    className={
                      active.approvals
                        ? "nav-item navbarActive navbarPadding"
                        : "nav-item navbarPadding"
                    }
                  >
                    <a
                      className="nav-link"
                      href=""
                      onClick={(e) => handleDashboard(e)}
                      style={{ color: "#fff" }}
                    >
                      Approvals
                    </a>
                  </li>
                  <li
                    className={
                      active.creatives
                        ? "nav-item navbarActive navbarPadding"
                        : "nav-item navbarPadding"
                    }
                  >
                    <a
                      className="nav-link"
                      href=""
                      onClick={(e) => handleDashboard(e)}
                      style={{ color: "#fff" }}
                    >
                      Creatives
                    </a>
                  </li>
                  <li
                    className={
                      active.post_event
                        ? "nav-item navbarActive navbarPadding"
                        : "nav-item navbarPadding"
                    }
                  >
                    <a
                      className="nav-link"
                      href=""
                      style={{ color: "#fff" }}
                      onClick={(e) => handleDashboard(e)}
                    >
                      Post Event
                    </a>
                  </li>
                </>
              ) : (
                role == 3 && (
                  <>
                    <li className="nav-item navbarActive navbarPadding">
                      <a
                        className="nav-link"
                        href=""
                        onClick={(e) => handleDashboard(e)}
                        style={{ color: "#fff" }}
                      >
                        Dashboard
                      </a>
                    </li>
                  </>
                )
              )}
            </ul>
          </div>
        </nav> */}
      </header>
    );
};

export default Header;
